export interface OnTranscriptionError {
  code?: number;

  message?: string;
}
